export enum EventType {
    RECONNECT_ERROR = 'reconnect_error',
    CONNECT_ERROR = 'connect_error',
    RECONNECTING = 'reconnecting',
    RECONNECT = 'reconnect',
    PING = 'PING',
    CONNECTION = 'connection',
    CONNECT = 'connect',
    DISCONNECT = 'disconnect',
    CREATE_MESSAGE = 'CREATE_MESSAGE',
    UPDATE_MEMBER_STATUS = 'UPDATE_MEMBER_STATUS',
    ERROR = 'error',
    NEW_ROOM = 'JOIN_ROOM',
    ACKNOWLEDGEMENT = 'DELETE_MESSAGE_TEMPORARY_DEVICE_TABLE',
    REMOVE_ROOM_AFTER_ASSIGN = 'REMOVE_ROOM_AFTER_ASSIGN',
    CLOSE_ROOM = 'CLOSE_ROOM',
    TYPING = 'TYPING',
    AUDIO = 'Recording audio...',
    STOP = 'STOP',
    MENTIONS_AGENT = 'MENTIONS_AGENT'
}

export enum tempEventType {
    ROOM_CREATED = 'room:created',
    ROOM_UPDATED = 'room:updated',
    ROOM_DELETED = 'room:deleted',
}